import {
  two_factor_complete_panel_default
} from "./chunk-5NO2ISKI.mjs";
import {
  TwoFactorTOTPForm
} from "./chunk-RVXJZR3B.mjs";
import {
  LoadingButton_default
} from "./chunk-5UPEKN6R.mjs";
import {
  SidePanelHeader
} from "./chunk-A2UNT4DX.mjs";

// src/internal/components/two-factor-panel/two-factor-activation-panel.tsx
import * as React from "react";
import { QRCodeCanvas } from "qrcode.react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";
import { useAuthContext, useTwoFactorActivationContext } from "@clara/auth";
import { Trans, Translation, useT } from "@clara/locale";
import { Flex, Banner } from "@clara/ui";
import { tap } from "@clara/utils";
import { jsx, jsxs } from "react/jsx-runtime";
function SidePanel(props) {
  const { t } = useT(["auth", "common"]);
  const activation = useTwoFactorActivationContext();
  const redirect = React.useCallback(() => {
    var _a, _b;
    const children = (_a = props.panels) == null ? void 0 : _a.slice(0, -1);
    const panels = [{ children }, two_factor_complete_panel_default];
    (_b = props.setPanels) == null ? void 0 : _b.call(props, panels, 1);
  }, []);
  React.useEffect(() => {
    activation.fetchQRCode();
  }, []);
  return /* @__PURE__ */ jsx(Stack, { spacing: 2, width: "100%", pb: 2, children: /* @__PURE__ */ jsxs(Stack, { spacing: 2, children: [
    /* @__PURE__ */ jsxs(Stepper, { orientation: "vertical", nonLinear: true, connector: /* @__PURE__ */ jsx(Box, { my: 1 }), children: [
      /* @__PURE__ */ jsx(Step, { active: true, children: /* @__PURE__ */ jsx(StepLabel, { sx: { alignItems: "flex-start" }, children: /* @__PURE__ */ jsx(Typography, { children: /* @__PURE__ */ jsx(
        Trans,
        {
          t,
          i18nKey: "twofactor.activation.step.one",
          components: {
            a: /* @__PURE__ */ jsx(Link, { target: "_blank", href: t("2fa.url.step.one.info") })
          },
          children: "Install a two-factor authentication app. We recommend some apps."
        }
      ) }) }) }),
      /* @__PURE__ */ jsx(Step, { active: true, children: /* @__PURE__ */ jsxs(Stack, { spacing: 2, children: [
        /* @__PURE__ */ jsx(StepLabel, { children: /* @__PURE__ */ jsx(Typography, { children: t("twofactor.activation.step.two") }) }),
        /* @__PURE__ */ jsx(
          Flex,
          {
            justify: "center",
            align: "center",
            height: (theme) => theme.spacing(18),
            children: activation.QRCode.loading ? /* @__PURE__ */ jsx(CircularProgress, {}) : activation.QRCode.value && /* @__PURE__ */ jsx(QRCodeCanvas, { value: activation.QRCode.value.uri })
          }
        ),
        /* @__PURE__ */ jsx(Banner, { status: "info", children: t("twofactor.activation.step.two.warning") })
      ] }) }),
      /* @__PURE__ */ jsx(Step, { active: true, children: /* @__PURE__ */ jsx(StepLabel, { children: /* @__PURE__ */ jsx(Typography, { children: t("twofactor.activation.step.three") }) }) })
    ] }),
    /* @__PURE__ */ jsx(
      TwoFactorTOTPForm,
      {
        error: activation.error,
        loading: activation.loading,
        onSubmit: (xs) => activation.activate(xs).then(tap(redirect))
      }
    )
  ] }) });
}
function WithSidePanel(props) {
  const { twoFactorAuthentication: twofactor } = useAuthContext();
  React.useEffect(() => {
    var _a;
    if (twofactor.enabled)
      (_a = props.prev) == null ? void 0 : _a.call(props);
  }, [twofactor.enabled, props.prev]);
  return /* @__PURE__ */ jsx(SidePanel, { ...props });
}
var TwoFaActivationPanelFooter = () => {
  var _a, _b;
  const { panelFormData } = useAuthContext();
  const { t } = useT("auth");
  return /* @__PURE__ */ jsx(
    LoadingButton_default,
    {
      type: "submit",
      form: panelFormData == null ? void 0 : panelFormData.formId,
      variant: "contained",
      loading: (_a = panelFormData == null ? void 0 : panelFormData.payload) == null ? void 0 : _a.loading,
      disabled: !((_b = panelFormData == null ? void 0 : panelFormData.payload) == null ? void 0 : _b.isValid),
      children: t("2fa.enabled.login.button.text")
    }
  );
};
var TwofactorActivationSidePanel = [
  {
    children: [
      {
        element: /* @__PURE__ */ jsx(WithSidePanel, {}),
        header: /* @__PURE__ */ jsx(Translation, { ns: "auth", children: (t) => /* @__PURE__ */ jsx(
          SidePanelHeader,
          {
            variant: "alternate",
            headline: t("twofactor.activation.process.headline")
          }
        ) }),
        footer: /* @__PURE__ */ jsx(TwoFaActivationPanelFooter, {})
      }
    ]
  }
];
var two_factor_activation_panel_default = TwofactorActivationSidePanel;

export {
  two_factor_activation_panel_default
};
